import { connect } from 'react-redux';

import { normalizePathname } from 'util/path';

import NavigationSide from './component';

const getPage = (hotel, pathname) => {
	const pathnames = normalizePathname(pathname);

	if (hotel) {
		return pathnames.length >= 4 ? pathnames[3] : '';
	}

	return pathnames[1] === '' ? 'main' : pathnames[1];
};

const mapStateToProps = ({
	global: { lan },
	routing: { locationBeforeTransitions: { pathname } },
	hotel: { hotel },
}) => ({
	lan,
	hotel,
	page: getPage(hotel, pathname),
});

export default connect(mapStateToProps)(NavigationSide);



// WEBPACK FOOTER //
// ./src/components/organisms/NavigationSide/index.js